import { TenantStatus } from '@debbie/common/dist/tenants/index.js'
import { c, h } from '@debbie/cortex/dist/index.js'
import { useMe, useMeTenant } from '@debbie/cortex/dist/me/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import {
  setTenantId,
  useTenant,
  useTenantId,
} from '@debbie/cortex/dist/tenant/index.js'
import { Location } from 'history'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, useLocation } from 'react-router-dom'

import DocumentSigning from './pages/cases/DocumentSigning.js'
import {
  Case,
  Cases,
  CreatePaymentPlan,
  Satisfaction,
} from './pages/cases/index.js'
import Overpayment from './pages/cases/Overpayment.js'

const LoggedInView = () => {
  const location: Location = useLocation()
  const lang = useSelector((s: RootState) => s.lang)
  const meLoadable = useMe()
  const me = h.hasData(meLoadable) ? meLoadable.data : null
  const meTenant = useMeTenant()
  const tenant = useTenant()
  const tenantId = useTenantId()

  useEffect(() => {
    if (meTenant) {
      const status =
        meTenant.status !== TenantStatus.Active
          ? `${lang.tenantStatus[meTenant.status]}: `
          : ''
      document.title = `${status}${meTenant.name} - Debbie`
    }
  }, [meTenant])

  useEffect(() => {
    if (!tenantId && me) {
      setTenantId(me.tenants[0].id)
    }
  }, [me])

  if (!tenant) {
    return null
  }

  return (
    <Switch location={location}>
      <Route exact path="/">
        <Cases />
      </Route>
      <Route exact path="/cases">
        <Cases />
      </Route>
      <Route path="/cases/:id" exact>
        <Case />
      </Route>
      <Route path="/cases/:id/paid" exact>
        <Case />
      </Route>
      <Route path="/cases/:id/payment-plan" exact>
        <CreatePaymentPlan />
      </Route>
      <Route path="/cases/:id/satisfaction" exact>
        <Satisfaction />
      </Route>
      <Route path="/cases/:id/overpayment" exact>
        <Overpayment />
      </Route>
      <Route path="/cases/:caseSequentialId/document-signing/:handle" exact>
        <DocumentSigning />
      </Route>
      <Route path="/cases/:id/satisfaction/:preSelectedSatisfaction" exact>
        <Satisfaction />
      </Route>
    </Switch>
  )
}

export default LoggedInView
